import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useSideMenuExpanded } from "hooks/useSideMenu";
import { motion } from "framer-motion";

export const HEADER_HEIGHT = "3rem";

export const ExpandSideMenuButton = () => {
  const { isExpanded, toggle } = useSideMenuExpanded();
  const theme = useTheme();

  return (
    <Box
      onClick={toggle}
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        borderBottom: "1px solid",
        borderColor: "divider",
        minHeight: HEADER_HEIGHT,
        pr: 2.75,
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "action.hover",
        },
      }}
    >
      <motion.div
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          width: "20px",
          height: "16px",
          cursor: "pointer",
        }}
      >
        <motion.div
          initial={false}
          animate={{
            width: isExpanded ? "10px" : "20px",
            x: isExpanded ? "10px" : "0px",
            opacity: isExpanded ? 0.6 : 1,
          }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 25,
          }}
          style={{
            height: "2.5px",
            borderRadius: "2px",
            backgroundColor: theme.palette.text.secondary,
          }}
        />
        <motion.div
          initial={false}
          animate={{
            width: isExpanded ? "6px" : "20px",
            x: isExpanded ? "14px" : "0px",
            opacity: isExpanded ? 0.4 : 1,
          }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 25,
            delay: 0.04,
          }}
          style={{
            height: "2.5px",
            borderRadius: "2px",
            backgroundColor: theme.palette.text.secondary,
          }}
        />
        <motion.div
          initial={false}
          animate={{
            width: isExpanded ? "12px" : "20px",
            x: isExpanded ? "8px" : "0px",
            opacity: isExpanded ? 0.8 : 1,
          }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 25,
            delay: 0.08,
          }}
          style={{
            height: "2.5px",
            borderRadius: "2px",
            backgroundColor: theme.palette.text.secondary,
          }}
        />
      </motion.div>
    </Box>
  );
};
